import React from 'react';
import { useT } from 'hooks/Locale/useT';
import './styles.scss'

interface TitleInterface {
    title: string;
    className?: string;
    withLine?: boolean;
}

const Title: React.FC<TitleInterface> = ({withLine, title, className = ''}) => {
    const t = useT();

    if (withLine) {
        return (
            <div className={`${className} title-with-line`}>
                <span>{t(title)}</span>
                {withLine && <div />}
            </div>
        );
    }

    return (
        <div className={className}>
            {t(title)}
        </div>
    );
};

export default Title;